
import moment from "moment";
import { addLocale } from 'primereact/api';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from "primereact/inputtext";
import { MultiSelect } from 'primereact/multiselect';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef, useState } from "react";
import Countdown from 'react-countdown';
import { useNavigate } from "react-router-dom";
import 'react-slideshow-image/dist/styles.css';
import '../../Helper/links';
import { _endPoints, getbookingscoming, getbookingsdel, getbookingsnow, getbookingsold } from "../../Helper/links";
import { pattern } from '../../Helper/pattern';
import API from "../../Helper/server/API";
import { ApartmentBodyTemplate, ApartmentsViewItemTemplate, CustomerTemplate, Date_CheckInBodyTemplate, Date_CheckOutBodyTemplate, DateCreate_BodyTemplate, DateUpdate_BodyTemplate, PaidViewTemplate, statusBodyTemplate, Total_discound_valueBodyTemplate, Total_PaidBodyTemplate, Total_PriceBodyTemplate, View_count_days, View_number_people, View_service_name } from "../../constants/dataView";
import { InvoiceContext } from '../../bookings/invoice/Invoice_Context';
import InvoiceBookinges from "../../bookings/invoice/invoice_bookinges";
import InvoiceCustomer from '../../bookings/invoice/invoice_customer';
import InvoiceCustomerDelete from "../../bookings/invoice/invoice_delete";
import DelReservations from '../../bookings/payments/del_reservation';
import PayReservations from '../../bookings/payments/pay_reservation';
import empty from '../../public/svg/empty.svg'
import { Accordion, AccordionTab } from 'primereact/accordion';
import ServiceReceiptMini from "../invoice/ServiceReceiptMini";

function Bookinges() {
    const Navigate = useNavigate();
    const toast = useRef(null);
    const items = Array.from({ length: 10 }, (v, i) => i);
    const Completionist = () => <span>تم الغاء الحجز</span>;
    addLocale('ar', {
        firstDayOfWeek: 6,
        dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        dayNamesMin: ['الأحد', 'الإثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
        monthNames: ['January-01', 'February-02', 'March-03', 'April-04', 'May-05', 'June-06', 'July-07', 'August-08', 'September-09', 'October-10', 'November-11', 'December-12'],
        monthNamesShort: ['Jan-01', 'Feb-02', 'Mar-03', 'Apr-04', 'May-05', 'Jun-06', 'Jul-07', 'Aug-08', 'Sep-09', 'Oct-10', 'Nov-11', 'Dec-12'],
        today: 'اليوم',
        clear: 'تفريغ',
    });
    const [year, setYear] = useState(new Date());
    const handel_year = (e) => {
        if (moment(e.value).format('YYYY') * 1 <= new Date().getFullYear() && moment(e.value).format('YYYY') * 1 >= new Date(new Date().setFullYear(2024)).getFullYear()) {
            setYear(e.value)
            GetReservationesComing(e.value.getFullYear())
            GetReservationesNow(e.value.getFullYear())
            GetReservationesOld(e.value.getFullYear())
            GetReservationesDel(e.value.getFullYear())
        }
    }
    const [apartments, setApartments] = useState([]);

    const [apartments_view, setApartments_view] = useState([]);
    const paid_type = ['all', 'paid', 'not_paid'];
    const [paid_type_view, setPaidTypeView] = useState('all');
    //_____________________________________________________________________
    const [reservationes_coming, setReservationes_coming] = useState([]);
    const [reservationes_old, setReservationes_old] = useState([]);
    const [reservationes_now, setReservationes_now] = useState([]);
    const [reservationes_del, setReservationes_del] = useState([]);

    const [reservationes_coming_view, setReservationes_coming_view] = useState([]);
    const [reservationes_old_view, setReservationes_old_view] = useState([]);
    const [reservationes_now_view, setReservationes_now_view] = useState([]);
    const [reservationes_del_view, setReservationes_del_view] = useState([]);
    //_____________________________________________________________________
    const [loading_apartment, set_loading_apartment] = useState(false);
    const [loading_reservationes_coming_view, set_loading_reservationes_coming_view] = useState(true);
    const [loading_reservationes_old_view, set_loading_reservationes_old_view] = useState(true);
    const [loading_reservationes_now_view, set_loading_reservationes_now_view] = useState(true);
    const [loading_reservationes_del_view, set_loading_reservationes_del_view] = useState(true);
    //_____________________________________________________________________
    const [selectedReservationes, setSelectedReservationes] = useState([]);
    //______________________________________________________________________
    const [search_date, setsearch_date] = useState([]);
    const [name_phone, setname_phone] = useState("");
    const [ID_reservation, setID_reservation] = useState("");
    const [disabled_search, set_disabled_search] = useState(false);
    //_______________________________________________________________________
    const ID_reservationBodyTemplate = (reservation) => {
        if (!reservation.date_del_reservation) return <>

            {reservation.ID_reservation}
            <p style={{ color: "green" }}>
                <i className="pi pi-check-circle"></i> مؤكد
            </p>
        </>;

        const target = new Date(reservation.date_del_reservation);
        const now = new Date();

        const diffMs = target - now; // فرق حقيقي بالميللي ثانية
        const diffDays = Math.max(0, Math.floor(diffMs / (1000 * 60 * 60 * 24)));

        return (
            <>
                {reservation.ID_reservation}
                <span style={{ color: "red" }}>
                    <br />
                    <Countdown date={target} renderer={renderer} />
                    <br />
                    {diffDays > 0 ? `${diffDays} أيام` : null}
                </span>
            </>
        );
    };

    const renderer = ({ hours, minutes, seconds, completed }) => {
        if (completed) {
            // Render a completed state
            return <Completionist />;
        } else {
            // Render a countdown
            return <span>
                {hours.toString().padStart(2, '0')}:{minutes.toString().padStart(2, '0')}:{seconds.toString().padStart(2, '0')}
            </span>;
        }
    };

    //____________________________________________________________
    const [Invoice, setInvoice] = useState(false);
    const [ViewPaid, setViewPaid] = useState(false);
    const [InvoicePaid, setInvoicePaid] = useState(false);
    const [dataPaid, setDataPaid] = useState(null);
    //____________________________________________________________
    const [ViewDelete, setViewDelete] = useState(false);
    const [InvoiceDelete, setInvoiceDelete] = useState(false);
    //____________________________________________________________

    const handel_ID_reservation = (e) => {
        if (pattern.number_int.test(e.target.value) === true) {
            setID_reservation(e.target.value);
            set_disabled_search(true);
        }
        else if (e.target.value === '' || e.target.value === null) {
            setID_reservation(e.target.value);
            set_disabled_search(false);
        }
    }



    const renderHeader = (tab) => {
        return (
            <div>
                <Accordion style={{ width: "100%" }}>
                    <AccordionTab header={<>
                        <div className="row">
                            <div className="col-md-6 col-4">
                                <h6 className="font-bold"><i className="pi pi-filter ml-1 mr-2 mt-2"></i> بحــث</h6>
                            </div>
                            <div className="col-md-6 col-8" style={{ textAlign: "left" }}>
                                <Button icon="fa fa-refresh ml-2" label="إعــادة تحمــيل"
                                    outlined onClick={(e) => {
                                        e.stopPropagation();
                                        GetReservationesComing(year.getFullYear())
                                        GetReservationesNow()
                                        GetReservationesOld()
                                        GetReservationesDel()
                                    }}
                                    disabled={
                                        loading_reservationes_coming_view || loading_reservationes_now_view || loading_reservationes_old_view || loading_reservationes_del_view ?
                                            true : false
                                    }
                                />
                            </div>
                        </div>

                    </>} >
                        <div className="row">
                            <div className="col-md-2">
                                <label>رقم الحجز</label>
                                <InputText
                                    value={ID_reservation}
                                    onChange={(e) => handel_ID_reservation(e)}
                                    placeholder="رقم الحجز"
                                    className="col-md-12"
                                    maxLength={6}
                                    style={{ fontFamily: "Cairo", fontSize: "15px", width: "100%" }}
                                />
                            </div>
                            <div className="col-md-3">
                                <label>الاسم - رقم الهاتف</label>
                                <InputText
                                    value={name_phone}
                                    onChange={(e) => setname_phone(e.target.value)}
                                    placeholder="الأسم أو رقم الهاتف"
                                    className="col-md-12"
                                    style={{ fontFamily: "Cairo", fontSize: "15px", width: "100%" }} disabled={disabled_search}
                                />
                            </div>
                            <div className="col-md-3">
                                <label>الخــدمة</label>
                                <MultiSelect
                                    options={apartments}
                                    value={apartments_view}
                                    itemTemplate={View_service_name}
                                    onChange={(e) => setApartments_view(e.target.value)}
                                    optionLabel="number"
                                    display="chip"
                                    placeholder="اختار مكان الخدمة"
                                    emptyMessage={<center><img src={empty} alt="empty" width={"10%"} className='m-4'></img><h3>لايــوجد حجــوزات</h3></center>}
                                    className="col-md-12"
                                    maxSelectedLabels={3}
                                    loading={loading_apartment}
                                    style={{ fontFamily: "Cairo", fontSize: "15px", width: "100%" }} disabled={disabled_search}
                                />

                            </div>
                            <div className="col-md-2">
                                <label>تـاريخ الدخـول</label>
                                <Calendar locale="ar" selectionMode="range" readOnlyInput hideOnRangeSelection placeholder="تاريخ الدخول"
                                    value={search_date} onChange={(e) => e.value ? setsearch_date(e.value) : setsearch_date([])} dateFormat="yy-mm-dd" showButtonBar
                                    style={{ fontFamily: "Cairo", width: "100%", paddingRight: "0px", paddingLeft: "0px" }} disabled={disabled_search}
                                    panelStyle={{ fontFamily: "Cairo", width: "auto" }}
                                />
                            </div>
                            <div className="col-md-2">
                                <label>المدفوع</label>
                                <Dropdown dir="rtl" value={paid_type_view} valueTemplate={PaidViewTemplate}
                                    options={paid_type} onChange={(e) => setPaidTypeView(e.value)}
                                    itemTemplate={PaidViewTemplate} className="col-md-12 p-0" style={{ width: "100%" }}
                                    panelStyle={{ textAlign: 'right', direction: "rtl" }} disabled={disabled_search} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 mt-2">
                                <center>
                                    <Button
                                        className="mt-2"
                                        type="button"
                                        label="تفـريغ"
                                        icon="fa fa-remove  ml-2"
                                        outlined
                                        severity="danger"
                                        onClick={clearFilter}
                                        style={{ marginRight: "5px" }}
                                        disabled={
                                            loading_reservationes_coming_view || loading_reservationes_now_view || loading_reservationes_old_view || loading_reservationes_del_view || loading_apartment ?
                                                true : false
                                        }
                                    />
                                    <Button
                                        className="mt-2"
                                        type="button"
                                        label="بحــث"
                                        icon="fa fa-search ml-2"
                                        outlined
                                        onClick={search}
                                        style={{ marginRight: "5px" }}
                                        disabled={
                                            loading_reservationes_coming_view || loading_reservationes_now_view || loading_reservationes_old_view || loading_reservationes_del_view || loading_apartment ?
                                                true : false
                                        }
                                    />
                                </center>
                            </div>

                        </div>
                    </AccordionTab>
                </Accordion>


            </div>
        );
    };
    const footer = () => {
        return (
            <>
                <div className="ibox-body" style={{ textAlign: "center" }}>
                    <div className="row" style={{ fontSize: "15px" }}>
                        <div className="col-md-4" >
                            <strong className="col-md-10">   تحديد {selectedReservationes.length} حجوزات </strong>
                            <Button
                                dir="ltr"
                                type="button"
                                icon="pi pi-filter-slash"
                                outlined
                                severity="danger"
                                onClick={() => { setSelectedReservationes([]) }}
                            />
                        </div>
                        <div className="col-md-8">
                            <>
                                <div className="row">
                                    <div className="col-md-3 col-6 mb-2">
                                        <Button icon="fa fa-print" dir="ltr" outlined label="طبــاعة " className="col-12" severity="secondary" aria-label="طباعة" onClick={print} disabled={selectedReservationes.length > 0 ? false : true} />
                                    </div>
                                    <div className="col-md-3 col-6 mb-2">
                                        <Button icon="fa fa-money" dir="ltr" outlined label=" قبــض" className="col-12" severity="success" onClick={ViewPaidReservationes} disabled={selectedReservationes.length > 0 ? false : true} />
                                    </div>
                                    <div className="col-md-3 col-6 mb-2">
                                        <Button disabled={true} icon="fa fa-edit" dir="ltr" outlined label="تعديــل" className="col-12" severity="info" aria-label="تعديل" onClick={ViewEditReservationes} />
                                    </div>
                                    <div className="col-md-3 col-6 mb-2">
                                        <Button disabled={false} icon="fa fa-trash" dir="ltr" className="col-12" outlined label="إلغــــاء" severity="danger" aria-label="حدف" onClick={ViewDeleteReservationes} />
                                    </div>
                                </div>
                            </>
                        </div>
                    </div>
                </div>
            </>
        )
    }
    const search = (e) => {
        e.preventDefault();

        //___________________________________________________________________
        //                  Search On Old Reservationes
        var reservationes_search_apt = [];
        var reservationes_search_coming = [];
        reservationes_coming?.map((res) =>
        (
            // eslint-disable-next-line array-callback-return
            apartments_view.map((apt) => {
                if (
                    res?.ID_service === apt?.ID_service
                ) {
                    reservationes_search_apt.push(res);
                }
            })
        ))
        // eslint-disable-next-line array-callback-return
        reservationes_search_apt?.map((res) => {
            if (ID_reservation !== '' && ID_reservation !== false) {
                if (res?.ID_reservation?.toString() === ID_reservation.toString()) {
                    reservationes_search_coming.push(res);
                }
            }
            else if (
                (
                    !name_phone || name_phone.toString().trim() === "" ||
                    (
                        (res.visitor_name != null && (res.visitor_name.toString().startsWith(name_phone.toString())
                            || res.visitor_name.toString().endsWith(name_phone.toString())))
                        //_____________________________________________
                        || (res.phone_number != null && (res.phone_number.toString().startsWith(name_phone.toString())
                            || res.phone_number.toString().endsWith(name_phone.toString())))
                        //_____________________________________________
                        || (res.whatsapp_number != null && (res.whatsapp_number.toString().startsWith(name_phone.toString())
                            || res.whatsapp_number.toString().endsWith(name_phone.toString())))
                    )
                )
                &&
                //_____________________________________________
                (
                    (paid_type_view === 'paid' && res.total_paid === res.total_price)
                    ||
                    (paid_type_view === 'not_paid' && res.total_paid !== res.total_price)
                    ||
                    paid_type_view === 'all'
                )
                &&
                (
                    (
                        search_date.length > 0
                        &&
                        moment(res.date_check_in).format('yyyy-MM-DD') >= moment(search_date[0]).format('yyyy-MM-DD')
                        &&
                        (
                            (
                                search_date.length > 1
                                &&
                                moment(res.date_check_in).format('yyyy-MM-DD') <= moment(search_date[1]).format('yyyy-MM-DD')
                            )
                            || search_date[1] === null
                        )
                    )
                    ||
                    search_date === null || search_date.length === 0

                )

            ) {
                reservationes_search_coming.push(res);
            }
        })
        setReservationes_coming_view(reservationes_search_coming);
        //___________________________________________________________________
        //                  Search On Old Reservationes
        reservationes_search_apt = [];
        var reservationes_search_old = [];
        // eslint-disable-next-line array-callback-return
        reservationes_old.map((res) => {
            // eslint-disable-next-line array-callback-return
            apartments_view.map((apt) => {
                if (
                    res?.ID_service === apt?.ID_service
                ) {
                    reservationes_search_apt.push(res);
                }

            })
        })
        // eslint-disable-next-line array-callback-return
        reservationes_search_apt.map((res) => {
            if (ID_reservation !== '' && ID_reservation !== false) {
                if (res.ID_reservation.toString() === ID_reservation.toString()) {
                    reservationes_search_old.push(res);
                }
            }
            else if (
                (
                    !name_phone || name_phone.toString().trim() === "" ||
                    (
                        (res.visitor_name != null && (res.visitor_name.toString().startsWith(name_phone.toString())
                            || res.visitor_name.toString().endsWith(name_phone.toString())))
                        //_____________________________________________
                        || (res.phone_number != null && (res.phone_number.toString().startsWith(name_phone.toString())
                            || res.phone_number.toString().endsWith(name_phone.toString())))
                        //_____________________________________________
                        || (res.whatsapp_number != null && (res.whatsapp_number.toString().startsWith(name_phone.toString())
                            || res.whatsapp_number.toString().endsWith(name_phone.toString())))
                    )
                )
                &&
                //_____________________________________________
                (
                    (paid_type_view === 'paid' && res.total_paid === res.total_price)
                    ||
                    (paid_type_view === 'not_paid' && res.total_paid !== res.total_price)
                    ||
                    paid_type_view === 'all'
                )
                &&
                (
                    (
                        search_date.length > 0
                        &&
                        moment(res.date_check_in).format('yyyy-MM-DD') >= moment(search_date[0]).format('yyyy-MM-DD')
                        &&
                        (
                            (
                                search_date.length > 1
                                &&
                                moment(res.date_check_in).format('yyyy-MM-DD') <= moment(search_date[1]).format('yyyy-MM-DD')
                            )
                            || search_date[1] === null
                        )
                    )
                    ||
                    search_date === null || search_date.length === 0

                )

            ) {
                reservationes_search_old.push(res);
            }
        })
        setReservationes_old_view(reservationes_search_old);
        //___________________________________________________________________
        //                  Search On Now Reservationes
        reservationes_search_apt = [];
        var reservationes_search_now = [];
        // eslint-disable-next-line array-callback-return
        reservationes_now.map((res) => {
            // eslint-disable-next-line array-callback-return
            apartments_view.map((apt) => {
                if (
                    res?.ID_service === apt?.ID_service
                ) {
                    reservationes_search_apt.push(res);
                }

            })
        })
        // eslint-disable-next-line array-callback-return
        reservationes_search_apt.map((res) => {
            if (ID_reservation !== '' && ID_reservation !== false) {
                if (res.ID_reservation.toString() === ID_reservation.toString()) {
                    reservationes_search_now.push(res);
                }
            }
            else if (
                (
                    !name_phone || name_phone.toString().trim() === "" ||
                    (
                        (res.visitor_name != null && (res.visitor_name.toString().startsWith(name_phone.toString())
                            || res.visitor_name.toString().endsWith(name_phone.toString())))
                        //_____________________________________________
                        || (res.phone_number != null && (res.phone_number.toString().startsWith(name_phone.toString())
                            || res.phone_number.toString().endsWith(name_phone.toString())))
                        //_____________________________________________
                        || (res.whatsapp_number != null && (res.whatsapp_number.toString().startsWith(name_phone.toString())
                            || res.whatsapp_number.toString().endsWith(name_phone.toString())))
                    )
                )
                &&
                //_____________________________________________
                (
                    (paid_type_view === 'paid' && res.total_paid === res.total_price)
                    ||
                    (paid_type_view === 'not_paid' && res.total_paid !== res.total_price)
                    ||
                    paid_type_view === 'all'
                )
                &&
                (
                    (
                        search_date.length > 0
                        &&
                        moment(res.date_check_in).format('yyyy-MM-DD') >= moment(search_date[0]).format('yyyy-MM-DD')
                        &&
                        (
                            (
                                search_date.length > 1
                                &&
                                moment(res.date_check_in).format('yyyy-MM-DD') <= moment(search_date[1]).format('yyyy-MM-DD')
                            )
                            || search_date[1] === null
                        )
                    )
                    ||
                    search_date === null || search_date.length === 0

                )

            ) {
                reservationes_search_now.push(res);
            }
        })
        setReservationes_now_view(reservationes_search_now);
        //___________________________________________________________________
        //                  Search On Delete Reservationes
        reservationes_search_apt = [];
        var reservationes_search_delete = [];
        // eslint-disable-next-line array-callback-return
        reservationes_del.map((res) => {
            // eslint-disable-next-line array-callback-return
            apartments_view.map((apt) => {
                if (
                    res.ID_apartment === apt.ID_apartment
                ) {
                    reservationes_search_apt.push(res);
                }

            })
        })
        // eslint-disable-next-line array-callback-return
        reservationes_search_apt.map((res) => {
            if (ID_reservation !== '' && ID_reservation !== false) {
                if (res.ID_reservation.toString() === ID_reservation.toString()) {
                    reservationes_search_delete.push(res);
                }
            }
            else if (
                (
                    !name_phone || name_phone.toString().trim() === "" ||
                    (
                        (res.visitor_name != null && (res.visitor_name.toString().startsWith(name_phone.toString())
                            || res.visitor_name.toString().endsWith(name_phone.toString())))
                        //_____________________________________________
                        || (res.phone_number != null && (res.phone_number.toString().startsWith(name_phone.toString())
                            || res.phone_number.toString().endsWith(name_phone.toString())))
                        //_____________________________________________
                        || (res.whatsapp_number != null && (res.whatsapp_number.toString().startsWith(name_phone.toString())
                            || res.whatsapp_number.toString().endsWith(name_phone.toString())))
                    )
                )
                &&
                //_____________________________________________
                (
                    (paid_type_view === 'paid' && res.total_paid === res.total_price)
                    ||
                    (paid_type_view === 'not_paid' && res.total_paid !== res.total_price)
                    ||
                    paid_type_view === 'all'
                )
                &&
                (
                    (
                        search_date.length > 0
                        &&
                        moment(res.date_check_in).format('yyyy-MM-DD') >= moment(search_date[0]).format('yyyy-MM-DD')
                        &&
                        (
                            (
                                search_date.length > 1
                                &&
                                moment(res.date_check_in).format('yyyy-MM-DD') <= moment(search_date[1]).format('yyyy-MM-DD')
                            )
                            || search_date[1] === null
                        )
                    )
                    ||
                    search_date === null || search_date.length === 0

                )

            ) {
                reservationes_search_delete.push(res);
            }
        })
        setReservationes_del_view(reservationes_search_delete);
    };
    const clearFilter = () => {
        setID_reservation("")
        setname_phone("");
        setsearch_date([])
        setPaidTypeView('all')
        GetApartment();
        GetReservationesComing(year.getFullYear())
        GetReservationesNow(year.getFullYear())
        GetReservationesOld(year.getFullYear())
        GetReservationesDel(year.getFullYear())
    };
    const print = () => {
        setInvoice(true);
    };
    const ViewPaidReservationes = () => {
        if (selectedReservationes.length > 0) {
            if (selectedReservationes.length > 1) {
                return (
                    toast.current.show({
                        style: {
                            fontFamily: "Cairo",
                            fontSize: "1.2rem"
                        },
                        life: 5000,
                        severity: 'error', summary: 'خطــاء', detail: 'ارجو اختيار حجز واحد'
                    })
                );
            }
            var id_customer = selectedReservationes[0]?.ID_customer;
            // eslint-disable-next-line array-callback-return
            selectedReservationes.map((res) => {
                if (res?.ID_customer !== id_customer && id_customer) {
                    id_customer = false;
                    return (
                        toast.current.show({
                            style: {
                                fontFamily: "Cairo",
                                fontSize: "1.2rem"
                            },
                            life: 5000,
                            severity: 'error', summary: 'خطــاء', detail: 'ارجو اختيار  حجوزات زبون واحد'
                        })
                    );
                }
            })
            if (id_customer) setViewPaid(true);
        }
        else {
            return (
                toast.current.show({
                    style: {
                        fontFamily: "Cairo",
                        fontSize: "1.2rem"
                    },
                    life: 5000,
                    severity: 'error', summary: 'خطــاء', detail: 'ارجو اختيار  حجوزات'
                })
            );
        }
    };
    const ViewEditReservationes = () => {
        if (selectedReservationes.length === 1) {
            var id_customer = selectedReservationes[0].ID_customer;
            // eslint-disable-next-line array-callback-return
            selectedReservationes.map((res) => {
                if (res.ID_customer !== id_customer) {
                    id_customer = false;
                    return (
                        toast.current.show({
                            style: {
                                fontFamily: "Cairo",
                                fontSize: "1.2rem"
                            },
                            life: 5000,
                            severity: 'error', summary: 'خطــاء', detail: 'ارجو اختيار  حجوزات زبون واحد'
                        })
                    );

                }
            })
            if (id_customer) {
                Navigate('/bookings-edit', {
                    state: {
                        reservation: selectedReservationes[0]
                        ,
                        customer: {
                            ID_customer: selectedReservationes[0].ID_customer,
                            id_user: "",
                            city: { id_city: null, name_city: '' },
                            visitor_name: selectedReservationes[0].visitor_name,
                            phone_number: selectedReservationes[0].phone_number,
                            whatsapp_number: selectedReservationes[0].whatsapp_number,
                            note: selectedReservationes[0].note,
                            state: 1,
                        }
                    }
                })
            }

        }
        else {
            return (
                toast.current.show({
                    style: {
                        fontFamily: "Cairo",
                        fontSize: "1.2rem"
                    },
                    life: 5000,
                    severity: 'error', summary: 'خطــاء', detail: 'ارجو اختيار  حجز واحد لتعديل'
                })
            );
        }
    };
    const ViewDeleteReservationes = () => {
        if (selectedReservationes.length > 0) {
            var id_customer = selectedReservationes[0].ID_customer;
            // eslint-disable-next-line array-callback-return
            selectedReservationes.map((res) => {
                if (res.ID_customer !== id_customer) {
                    id_customer = false;
                    return (
                        toast.current.show({
                            style: {
                                fontFamily: "Cairo",
                                fontSize: "1.2rem"
                            },
                            life: 5000,
                            severity: 'error', summary: 'خطــاء', detail: 'ارجو اختيار  حجوزات زبون واحد'
                        })
                    );

                }
            })
            // if (id_customer) setViewDelete(true);
            setViewDelete(true);

        }
        else {
            return (
                toast.current.show({
                    style: {
                        fontFamily: "Cairo",
                        fontSize: "1.2rem"
                    },
                    life: 5000,
                    severity: 'error', summary: 'خطــاء', detail: 'ارجو اختيار  حجوزات'
                })
            );
        }
    };
    //_______________________________________________________________________________________
    //                      Get Reservationes
    const GetApartment = async () => {
        set_loading_apartment(true);
        const response = await API.get(_endPoints.reservations.services.get_all)
        if (response?.success === 1) {
            const formatted = response.data.map(srv => ({
                ...srv,
                ID_apartment: srv.ID_service,
                number: srv.service_name_ar || srv.name
            }));
            setApartments(formatted);
            setApartments_view(formatted);
        }
        set_loading_apartment(false);
    }
    const GetReservationesComing = async (year) => {
        set_loading_reservationes_coming_view(true)
        if (!year)
            year = new Date().getFullYear()
        const response = await API.get(`${_endPoints.reservations.services.get_coming}?year=${year}`)
        if (response?.success === 1) {
            setReservationes_coming(response.data);
            //__________________________________________________________
            setReservationes_coming_view(response.data);
            // Filter Reservationes
        }
        else {
            toast.current.show({
                style: {
                    fontFamily: "Cairo",
                    fontSize: "1.2rem"
                },
                life: 5000,
                severity: 'error', summary: 'خطــاء', detail: response?.msg
            });
        }
        set_loading_reservationes_coming_view(false)

    }
    const GetReservationesNow = async (year) => {
        set_loading_reservationes_now_view(true)
        if (!year)
            year = new Date().getFullYear()
        const response = await API.get(`${_endPoints.reservations.services.get_now}?year=${year}`)
        if (response?.success === 1) {
            setReservationes_now(response.data);
            //__________________________________________________________
            setReservationes_now_view(response.data);
            // Filter Reservationes
        }
        else {
            toast.current.show({
                style: {
                    fontFamily: "Cairo",
                    fontSize: "1.2rem"
                },
                life: 5000,
                severity: 'error', summary: 'خطــاء', detail: response?.msg
            });
        }
        set_loading_reservationes_now_view(false)

    }
    const GetReservationesOld = async (year) => {
        set_loading_reservationes_old_view(true)
        if (!year)
            year = new Date().getFullYear()
        const response = await API.get(`${_endPoints.reservations.services.get_old}?year=${year}`)
        if (response?.success === 1) {
            setReservationes_old(response.data);
            setReservationes_old_view(response.data);
            // Filter Reservationes
        }
        else {
            toast.current.show({
                style: {
                    fontFamily: "Cairo",
                    fontSize: "1.2rem"
                },
                life: 5000,
                severity: 'error', summary: 'خطــاء', detail: response?.msg
            });
        }
        set_loading_reservationes_old_view(false)

    }
    const GetReservationesDel = async (year) => {
        set_loading_reservationes_del_view(true)
        if (!year)
            year = new Date().getFullYear()
        const response = await API.get(`${_endPoints.reservations.services.get_del}?year=${year}`)
        if (response?.success === 1) {
            setReservationes_del(response.data);
            //__________________________________________________________
            setReservationes_del_view(response.data);
            // Filter Reservationes
        }
        else {
            toast.current.show({
                style: {
                    fontFamily: "Cairo",
                    fontSize: "1.2rem"
                },
                life: 5000,
                severity: 'error', summary: 'خطــاء', detail: response?.msg
            });
        }
        set_loading_reservationes_del_view(false)

    }
    useEffect(() => {
        GetApartment();
        GetReservationesComing(new Date().getFullYear());
        GetReservationesNow(new Date().getFullYear());
        GetReservationesOld(new Date().getFullYear());
        GetReservationesDel(new Date().getFullYear());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const scrollStyle = {
        overflowY: "auto",
        scrollbarWidth: "thin", // للمتصفحات غير Chrome

    };
    const scrollBarCSS = `
   ::-webkit-scrollbar {
        display: block !important;
        width: 5px;
        height: 8px;
    }
    `;

    return (
        <div className="page-wrapper" dir="rtl" >
            <div className="content-wrapper">
                <Toast ref={toast} position="top-center" style={{ margin: "0 1rem 0 0 !important", fontFamily: "Cairo" }} remove />

                <div className="page-heading">
                    <h1 className="page-title">عـــرض الحجــوزات
                        <Calendar value={year} onChange={(e) => handel_year(e)} view="year" dateFormat="yy" className="col-md-1 mt-2" style={{ fontFamily: "Cairo" }} panelStyle={{ fontFamily: "Cairo" }}
                            minDate={new Date(new Date().setFullYear(2024))}
                            maxDate={new Date()}
                            disabled={loading_reservationes_coming_view || loading_reservationes_now_view || loading_reservationes_old_view || loading_reservationes_del_view}
                        />
                    </h1>
                </div>
                <div className="card">
                    <div >
                        {renderHeader('')}
                    </div>
                    <div className="clf">
                        <ul className="nav nav-tabs tabs-line nav-fill" style={{ backgroundColor: "#f8f9fa", marginBottom: "0px", width: "100%" }}>
                            <li className="nav-item col-12 col-md-3">
                                <a className="nav-link active" href="#tab-1" data-toggle="tab">
                                    <h6>القــادمة {loading_reservationes_coming_view ? <>-</> : reservationes_coming_view?.length}</h6>
                                </a>
                            </li>
                            <li className="nav-item col-12 col-md-3">
                                <a className="nav-link" href="#tab-2" data-toggle="tab">
                                    <h6>الحـــالية {loading_reservationes_now_view ? <>-</> : reservationes_now_view?.length}</h6>
                                </a>
                            </li>
                            <li className="nav-item col-12 col-md-3">
                                <a className="nav-link" href="#tab-3" data-toggle="tab">
                                    <h6>المنتهـــية {loading_reservationes_old_view ? <>-</> : reservationes_old_view?.length}</h6>
                                </a>
                            </li>
                            <li className="nav-item col-12 col-md-3" >
                                <a className="nav-link" href="#tab-4" data-toggle="tab">
                                    <h6>الملـــغية {loading_reservationes_del_view ? <>-</> : reservationes_del_view?.length}</h6>
                                </a>
                            </li>
                        </ul>
                        <div className="tab-content">
                            <div className="tab-pane  show active" id="tab-1">
                                <style>{scrollBarCSS}</style>
                                {/* {renderHeader("coming")} */}
                                {
                                    loading_reservationes_coming_view ?
                                        <DataTable value={items} className="p-datatable-striped" tableStyle={{ minWidth: '50rem' }} style={{ fontFamily: "Cairo", direction: "rtl" }}>
                                            <Column selectionMode="multiple" style={{ width: '1%', textAlign: "right" }}></Column>
                                            <Column field="ID_reservation" header="الحجز" sortable style={{ width: '2%', textAlign: "right" }} body={<Skeleton />}></Column>
                                            <Column field="visitor_name" header="العميــل" sortable style={{ width: '10%', textAlign: "right" }} body={<Skeleton />}></Column>
                                            <Column field="number" header="الخدمة" showFilterMenu={false} filterMenuStyle={{ width: '14rem' }} sortable style={{ width: '5%', textAlign: "right" }} body={<Skeleton />}></Column>
                                            <Column field="date_check_in" header="الدخول" sortable style={{ width: '10%', textAlign: "right" }} body={<Skeleton />}></Column>
                                            {/* <Column field="date_check_out" header="المغادرة" sortable style={{ width: '10%', textAlign: "right" }} body={<Skeleton />}></Column> */}
                                            {/* <Column field="date_check_in" header="الايام" style={{ width: '1%', textAlign: "right" }} body={<Skeleton />}></Column> */}
                                            <Column field="total_price" header="السعر" sortable style={{ width: '5%', textAlign: "right" }} body={<Skeleton />}></Column>
                                            <Column field="total_paid" header="المدفوع" sortable style={{ width: '5%', textAlign: "right", color: "green" }} body={<Skeleton />}></Column>
                                            <Column header="الباقي" field="rest" sortable style={{ width: '8%', textAlign: "right", color: "red" }} body={<Skeleton />}></Column>
                                            <Column field="discount_value" header="التخفيض" sortable style={{ width: '5%', textAlign: "right" }} body={<Skeleton />}></Column>
                                            <Column field="notes" header="ملاحظات" style={{ width: '5%', textAlign: "right" }} body={<Skeleton />}></Column>
                                            {/* <Column field="date_del_reservation" header="وفت الغاء الحجز" body={DateDel_BodyTemplate} sortable  style={{ width: '10%',textAlign:"right" }}></Column> */}
                                            <Column field="date_create" header="وقت الحجز" sortable style={{ width: '10%', textAlign: "right" }} body={<Skeleton />}></Column>
                                            <Column field="name" header="الحجز عن طريق" style={{ width: '10%', textAlign: "right" }} body={<Skeleton />}></Column>
                                        </DataTable>
                                        :
                                        <DataTable value={reservationes_coming_view} loading={loading_reservationes_coming_view}
                                            dataKey="ID_reservation"
                                            selectionMode="multiple" selection={selectedReservationes} onSelectionChange={(e) => setSelectedReservationes(e.value)}
                                            metaKeySelection={false} dragSelection
                                            stripedRows removableSort
                                            paginator rows={10} rowsPerPageOptions={[10, 20, 30, 50]}
                                            scrollable scrollHeight="650px"
                                            sortMode="multiple"
                                            className="custom-scrollbar"
                                            size="normal"
                                            footer={footer}
                                            emptyMessage={<center><img src={empty} alt="empty" width={"10%"} className='m-4'></img><h3>لايــوجد حجــوزات</h3></center>}
                                            tableStyle={scrollStyle}
                                            style={{ fontFamily: "Cairo", direction: "rtl", fontSize: "15px", border: "10px" }}
                                        >
                                            <Column selectionMode="multiple" style={{ width: '1%', textAlign: "right" }}></Column>
                                            <Column field="ID_reservation" body={ID_reservationBodyTemplate} header="الحجز" sortable style={{ width: '7%', textAlign: "right" }}></Column>
                                            <Column field="visitor_name" body={CustomerTemplate} header="العميــل" sortable style={{ width: '10%', textAlign: "right" }}></Column>
                                            <Column field="number" header="الخدمة" showFilterMenu={false} filterMenuStyle={{ width: '14rem' }}
                                                body={ApartmentBodyTemplate} sortable style={{ width: '5%', textAlign: "right" }}></Column>
                                            <Column field="date_check_in" header="الدخول" body={Date_CheckInBodyTemplate} sortable style={{ width: '10%', textAlign: "right" }}></Column>
                                            {/* <Column field="date_check_out" header="المغادرة" body={Date_CheckOutBodyTemplate} sortable style={{ width: '10%', textAlign: "right" }}></Column> */}
                                            {/* <Column field="date_check_in" header="الايام" body={View_count_days} style={{ width: '1%', textAlign: "right" }}></Column> */}
                                            <Column field="total_price" header="السعر" body={Total_PriceBodyTemplate} sortable style={{ width: '5%', textAlign: "right" }}></Column>
                                            <Column field="total_paid" header="المدفوع" body={Total_PaidBodyTemplate} sortable style={{ width: '5%', textAlign: "right", color: "green" }}></Column>
                                            <Column header="الباقي" field="rest" body={statusBodyTemplate} sortable style={{ width: '8%', textAlign: "right", color: "red" }} ></Column>
                                            <Column field="discount_value" header="التخفيض" body={Total_discound_valueBodyTemplate} sortable style={{ width: '5%', textAlign: "right" }}></Column>
                                            <Column field="notes" header="ملاحظات" style={{ width: '5%', textAlign: "right" }}></Column>
                                            {/* <Column field="date_del_reservation" header="وفت الغاء الحجز" body={DateDel_BodyTemplate} sortable  style={{ width: '10%',textAlign:"right" }}></Column> */}
                                            <Column field="date_create" header="وقت الحجز" body={DateCreate_BodyTemplate} sortable style={{ width: '10%', textAlign: "right" }}></Column>
                                            <Column field="name" header="الحجز عن طريق" style={{ width: '10%', textAlign: "right" }}></Column>
                                        </DataTable>
                                }

                            </div>
                            <div className="tab-pane " id="tab-2">
                                <style>{scrollBarCSS}</style>
                                {/* {renderHeader("now")} */}
                                {
                                    loading_reservationes_now_view ?
                                        <DataTable value={items} className="p-datatable-striped" tableStyle={{ minWidth: '50rem' }} style={{ fontFamily: "Cairo", direction: "rtl" }}>
                                            <Column selectionMode="multiple" style={{ width: '1%', textAlign: "right" }}></Column>
                                            <Column field="ID_reservation" header="الحجز" sortable style={{ width: '2%', textAlign: "right" }} body={<Skeleton />}></Column>
                                            <Column field="visitor_name" header="العميــل" sortable style={{ width: '10%', textAlign: "right" }} body={<Skeleton />}></Column>
                                            <Column field="number" header="الخدمة" showFilterMenu={false} filterMenuStyle={{ width: '14rem' }} sortable style={{ width: '5%', textAlign: "right" }} body={<Skeleton />}></Column>
                                            <Column field="date_check_in" header="الدخول" sortable style={{ width: '10%', textAlign: "right" }} body={<Skeleton />}></Column>
                                            {/* <Column field="date_check_out" header="المغادرة" sortable style={{ width: '10%', textAlign: "right" }} body={<Skeleton />}></Column> */}
                                            {/* <Column field="date_check_in" header="الايام" style={{ width: '1%', textAlign: "right" }} body={<Skeleton />}></Column> */}
                                            <Column field="total_price" header="السعر" sortable style={{ width: '5%', textAlign: "right" }} body={<Skeleton />}></Column>
                                            <Column field="total_paid" header="المدفوع" sortable style={{ width: '5%', textAlign: "right", color: "green" }} body={<Skeleton />}></Column>
                                            <Column header="الباقي" field="rest" sortable style={{ width: '8%', textAlign: "right", color: "red" }} body={<Skeleton />}></Column>
                                            <Column field="discount_value" header="التخفيض" sortable style={{ width: '5%', textAlign: "right" }} body={<Skeleton />}></Column>
                                            <Column field="notes" header="ملاحظات" style={{ width: '5%', textAlign: "right" }} body={<Skeleton />}></Column>
                                            {/* <Column field="date_del_reservation" header="وفت الغاء الحجز" body={DateDel_BodyTemplate} sortable  style={{ width: '10%',textAlign:"right" }}></Column> */}
                                            <Column field="date_create" header="وقت الحجز" sortable style={{ width: '10%', textAlign: "right" }} body={<Skeleton />}></Column>
                                            <Column field="name" header="الحجز عن طريق" style={{ width: '10%', textAlign: "right" }} body={<Skeleton />}></Column>
                                        </DataTable>
                                        :
                                        <DataTable value={reservationes_now_view} loading={loading_reservationes_now_view}
                                            selection={selectedReservationes} onSelectionChange={(e) => setSelectedReservationes(e.value)}
                                            metaKeySelection={false} dragSelection
                                            stripedRows removableSort
                                            //paginator rows={10} rowsPerPageOptions={[10, 20, 30, 50]}
                                            scrollable scrollHeight="650px"
                                            size="normal"
                                            sortMode="multiple"
                                            footer={footer}
                                            emptyMessage={<center><img src={empty} alt="empty" width={"10%"} className='m-4'></img><h3>لايــوجد حجــوزات</h3></center>}
                                            tableStyle={scrollStyle}
                                            style={{ fontFamily: "Cairo", direction: "rtl", fontSize: "15px" }} >
                                            <Column selectionMode="multiple" style={{ width: '1%', textAlign: "right" }}></Column>
                                            <Column field="ID_reservation" body={ID_reservationBodyTemplate} header="الحجز" sortable style={{ width: '2%', textAlign: "right" }}></Column>
                                            <Column field="visitor_name" body={CustomerTemplate} header="العميــل" sortable style={{ width: '10%', textAlign: "right" }}></Column>
                                            <Column field="number" header="الخدمة" showFilterMenu={false} filterMenuStyle={{ width: '14rem' }}
                                                body={ApartmentBodyTemplate} sortable style={{ width: '5%', textAlign: "right" }}></Column>
                                            {/* <Column field="number_people" header="عدد الأشخاص" showFilterMenu={false} filterMenuStyle={{ width: '14rem' }}
                                                body={View_number_people} sortable style={{ width: '5%', textAlign: "right" }}></Column> */}
                                            <Column field="date_check_in" header="الدخول" body={Date_CheckInBodyTemplate} sortable style={{ width: '10%', textAlign: "right" }}></Column>
                                            {/* <Column field="date_check_out" header="المغادرة" body={Date_CheckOutBodyTemplate} sortable style={{ width: '10%', textAlign: "right" }}></Column> */}
                                            {/* <Column field="date_check_in" header="الايام" body={View_count_days} style={{ width: '1%', textAlign: "right" }}></Column> */}
                                            <Column field="total_price" header="السعر" body={Total_PriceBodyTemplate} sortable style={{ width: '5%', textAlign: "right" }}></Column>
                                            <Column field="total_paid" header="المدفوع" body={Total_PaidBodyTemplate} sortable style={{ width: '5%', textAlign: "right", color: "green" }}></Column>
                                            <Column header="الباقي" field="rest" body={statusBodyTemplate} sortable style={{ width: '8%', textAlign: "right", color: "red" }} ></Column>
                                            <Column field="discount_value" header="التخفيض" body={Total_discound_valueBodyTemplate} sortable style={{ width: '5%', textAlign: "right" }}></Column>
                                            <Column field="notes" header="ملاحظات" style={{ width: '5%', textAlign: "right" }}></Column>
                                            {/* <Column field="date_del_reservation" header="وفت الغاء الحجز" body={DateDel_BodyTemplate} sortable  style={{ width: '10%',textAlign:"right" }}></Column> */}
                                            <Column field="date_create" header="وقت الحجز" body={DateCreate_BodyTemplate} sortable style={{ width: '10%', textAlign: "right" }}></Column>
                                            <Column field="name" header="الحجز عن طريق" style={{ width: '10%', textAlign: "right" }}></Column>
                                        </DataTable>
                                }
                            </div>
                            <div className="tab-pane " id="tab-3">
                                <style>{scrollBarCSS}</style>
                                {/* {renderHeader("old")} */}
                                {
                                    loading_reservationes_old_view ?
                                        <DataTable value={items} className="p-datatable-striped" tableStyle={{ minWidth: '50rem' }} style={{ fontFamily: "Cairo", direction: "rtl" }}>
                                            <Column selectionMode="multiple" style={{ width: '1%', textAlign: "right" }}></Column>
                                            <Column field="ID_reservation" header="الحجز" sortable style={{ width: '2%', textAlign: "right" }} body={<Skeleton />}></Column>
                                            <Column field="visitor_name" header="العميــل" sortable style={{ width: '10%', textAlign: "right" }} body={<Skeleton />}></Column>
                                            <Column field="number" header="الخدمة" showFilterMenu={false} filterMenuStyle={{ width: '14rem' }} sortable style={{ width: '5%', textAlign: "right" }} body={<Skeleton />}></Column>
                                            <Column field="date_check_in" header="الدخول" sortable style={{ width: '10%', textAlign: "right" }} body={<Skeleton />}></Column>
                                            {/* <Column field="date_check_out" header="المغادرة" sortable style={{ width: '10%', textAlign: "right" }} body={<Skeleton />}></Column> */}
                                            {/* <Column field="date_check_in" header="الايام" style={{ width: '1%', textAlign: "right" }} body={<Skeleton />}></Column> */}
                                            <Column field="total_price" header="السعر" sortable style={{ width: '5%', textAlign: "right" }} body={<Skeleton />}></Column>
                                            <Column field="total_paid" header="المدفوع" sortable style={{ width: '5%', textAlign: "right", color: "green" }} body={<Skeleton />}></Column>
                                            <Column header="الباقي" field="rest" sortable style={{ width: '8%', textAlign: "right", color: "red" }} body={<Skeleton />}></Column>
                                            <Column field="discount_value" header="التخفيض" sortable style={{ width: '5%', textAlign: "right" }} body={<Skeleton />}></Column>
                                            <Column field="notes" header="ملاحظات" style={{ width: '5%', textAlign: "right" }} body={<Skeleton />}></Column>
                                            {/* <Column field="date_del_reservation" header="وفت الغاء الحجز" body={DateDel_BodyTemplate} sortable  style={{ width: '10%',textAlign:"right" }}></Column> */}
                                            <Column field="date_create" header="وقت الحجز" sortable style={{ width: '10%', textAlign: "right" }} body={<Skeleton />}></Column>
                                            <Column field="name" header="الحجز عن طريق" style={{ width: '10%', textAlign: "right" }} body={<Skeleton />}></Column>
                                        </DataTable>
                                        :
                                        <DataTable value={reservationes_old_view} loading={loading_reservationes_old_view}
                                            dataKey="ID_reservation"
                                            selectionMode="multiple" selection={selectedReservationes} onSelectionChange={(e) => setSelectedReservationes(e.value)}
                                            metaKeySelection={false} dragSelection
                                            stripedRows removableSort
                                            paginator rows={10} rowsPerPageOptions={[10, 20, 30, 50]}
                                            // paginator rows={10} rowsPerPageOptions={[10, 20, 30, 50]}
                                            scrollable scrollHeight="650px"
                                            size="normal"
                                            sortMode="multiple"
                                            footer={footer}
                                            emptyMessage={<center><img src={empty} alt="empty" width={"10%"} className='m-4'></img><h3>لايــوجد حجــوزات</h3></center>}
                                            tableStyle={scrollStyle}
                                            style={{ fontFamily: "Cairo", textAlign: "right", direction: "rtl", fontSize: "15px" }} >
                                            <Column selectionMode="multiple" style={{ width: '1%', textAlign: "right" }}></Column>
                                            <Column field="ID_reservation" body={ID_reservationBodyTemplate} header="الحجز" sortable style={{ width: '2%', textAlign: "right" }}></Column>
                                            <Column field="visitor_name" body={CustomerTemplate} header="العميــل" sortable style={{ width: '10%', textAlign: "right" }}></Column>
                                            <Column field="number" header="الخدمة" showFilterMenu={false} filterMenuStyle={{ width: '14rem' }}
                                                body={View_service_name} sortable style={{ width: '5%', textAlign: "right" }}></Column>
                                            <Column field="number_people" header="الأشخاص" showFilterMenu={false} filterMenuStyle={{ width: '5rem' }}
                                                sortable style={{ width: '5%', textAlign: "right" }}></Column>
                                            <Column field="date_check_in" header="الدخول" body={Date_CheckInBodyTemplate} sortable style={{ width: '10%', textAlign: "right" }}></Column>
                                            {/* <Column field="date_check_out" header="المغادرة" body={Date_CheckOutBodyTemplate} sortable style={{ width: '10%', textAlign: "right" }}></Column> */}
                                            {/* <Column field="date_check_in" header="الايام" body={View_count_days} style={{ width: '1%', textAlign: "right" }}></Column> */}
                                            <Column field="total_price" header="السعر" body={Total_PriceBodyTemplate} sortable style={{ width: '5%', textAlign: "right" }}></Column>
                                            <Column field="total_paid" header="المدفوع" body={Total_PaidBodyTemplate} sortable style={{ width: '5%', textAlign: "right", color: "green" }}></Column>
                                            <Column header="الباقي" field="rest" body={statusBodyTemplate} sortable style={{ width: '8%', textAlign: "right", color: "red" }} ></Column>
                                            <Column field="discount_value" header="التخفيض" body={Total_discound_valueBodyTemplate} sortable style={{ width: '5%', textAlign: "right" }}></Column>
                                            <Column field="notes" header="ملاحظات" style={{ width: '5%', textAlign: "right" }}></Column>
                                            {/* <Column field="date_del_reservation" header="وفت الغاء الحجز" body={DateDel_BodyTemplate} sortable  style={{ width: '10%',textAlign:"right" }}></Column> */}
                                            <Column field="date_create" header="وقت الحجز" body={DateCreate_BodyTemplate} sortable style={{ width: '10%', textAlign: "right" }}></Column>
                                            <Column field="name" header="الحجز عن طريق" style={{ width: '10%', textAlign: "right" }}></Column>
                                        </DataTable>
                                }
                            </div>
                            <div className="tab-pane" id="tab-4">
                                <style>{scrollBarCSS}</style>
                                {/* {renderHeader("del")} */}
                                {
                                    loading_reservationes_del_view ?
                                        <DataTable value={items} className="p-datatable-striped" tableStyle={{ minWidth: '50rem' }} style={{ fontFamily: "Cairo", direction: "rtl" }}>
                                            <Column field="ID_reservation" header="الحجز" sortable style={{ width: '2%', textAlign: "right" }} body={<Skeleton />}></Column>
                                            <Column field="visitor_name" header="العميــل" sortable style={{ width: '10%', textAlign: "right" }} body={<Skeleton />}></Column>
                                            <Column field="number" header="الخدمة" showFilterMenu={false} filterMenuStyle={{ width: '14rem' }} sortable style={{ width: '5%', textAlign: "right" }} body={<Skeleton />}></Column>
                                            <Column field="date_check_in" header="الدخول" sortable style={{ width: '10%', textAlign: "right" }} body={<Skeleton />}></Column>
                                            {/* <Column field="date_check_out" header="المغادرة" sortable style={{ width: '10%', textAlign: "right" }} body={<Skeleton />}></Column> */}
                                            {/* <Column field="date_check_in" header="الايام" style={{ width: '1%', textAlign: "right" }} body={<Skeleton />}></Column> */}
                                            <Column field="total_price" header="السعر" sortable style={{ width: '5%', textAlign: "right" }} body={<Skeleton />}></Column>
                                            <Column field="total_paid" header="المدفوع" sortable style={{ width: '5%', textAlign: "right", color: "green" }} body={<Skeleton />}></Column>
                                            <Column header="الباقي" field="rest" sortable style={{ width: '8%', textAlign: "right", color: "red" }} body={<Skeleton />}></Column>
                                            <Column field="discount_value" header="التخفيض" sortable style={{ width: '5%', textAlign: "right" }} body={<Skeleton />}></Column>
                                            <Column field="notes" header="ملاحظات" style={{ width: '5%', textAlign: "right" }} body={<Skeleton />}></Column>
                                            <Column field="date_update" header="وقت الغاء الحجز" sortable style={{ width: '10%', textAlign: "right" }} body={<Skeleton />}></Column>
                                            <Column field="date_create" header="وقت الحجز" sortable style={{ width: '10%', textAlign: "right" }} body={<Skeleton />}></Column>
                                            <Column field="name" header="الحجز عن طريق" style={{ width: '10%', textAlign: "right" }} body={<Skeleton />}></Column>
                                        </DataTable>
                                        :
                                        <DataTable value={reservationes_del_view} loading={loading_reservationes_del_view}
                                            dataKey="ID_reservation"
                                            selectionMode="multiple"
                                            metaKeySelection={false} dragSelection
                                            stripedRows removableSort
                                            paginator rows={10} rowsPerPageOptions={[10, 20, 30, 50]}
                                            scrollable scrollHeight="650px"
                                            sortMode="multiple"
                                            size="normal"
                                            emptyMessage={<center><img src={empty} alt="empty" width={"10%"} className='m-4'></img><h3>لايــوجد حجــوزات</h3></center>}
                                            tableStyle={scrollStyle}
                                            style={{ fontFamily: "Cairo", direction: "rtl", fontSize: "15px", border: "10px" }} >
                                            <Column field="ID_reservation" header="الحجز" sortable style={{ width: '2%', textAlign: "right", color: "red" }}></Column>
                                            <Column field="visitor_name" body={CustomerTemplate} header="العميــل" sortable style={{ width: '10%', textAlign: "right" }}></Column>
                                            <Column field="number" header="الخدمة" showFilterMenu={false} filterMenuStyle={{ width: '14rem' }}
                                                body={View_service_name} sortable style={{ width: '5%', textAlign: "right" }}></Column>
                                            <Column field="date_check_in" header="الدخول" body={Date_CheckInBodyTemplate} sortable style={{ width: '10%', textAlign: "right" }}></Column>
                                            {/* <Column field="date_check_out" header="المغادرة" body={Date_CheckOutBodyTemplate} sortable style={{ width: '10%', textAlign: "right" }}></Column> */}
                                            {/* <Column field="date_check_in" header="الايام" body={View_count_days} style={{ width: '1%', textAlign: "right" }}></Column> */}
                                            <Column field="total_price" header="السعر" body={Total_PriceBodyTemplate} sortable style={{ width: '5%', textAlign: "right" }}></Column>
                                            <Column field="total_paid" header="المدفوع" body={Total_PaidBodyTemplate} sortable style={{ width: '5%', textAlign: "right", color: "green" }}></Column>
                                            <Column header="الباقي" field="rest" body={statusBodyTemplate} sortable style={{ width: '8%', textAlign: "right", color: "red" }} ></Column>
                                            <Column field="discount_value" header="التخفيض" body={Total_discound_valueBodyTemplate} sortable style={{ width: '5%', textAlign: "right" }}></Column>
                                            <Column field="notes" header="ملاحظات" style={{ width: '5%', textAlign: "right" }}></Column>
                                            <Column field="date_create" header="وقت الحجز" body={DateCreate_BodyTemplate} sortable style={{ width: '10%', textAlign: "right" }}></Column>
                                            <Column field="date_update" header="وقت الغاء الحجز" body={DateUpdate_BodyTemplate} sortable style={{ width: '10%', textAlign: "right" }}></Column>
                                            <Column field="name" header="الحجز عن طريق" style={{ width: '10%', textAlign: "right" }}></Column>
                                        </DataTable>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                {
                    Invoice ?
                        (
                            <Dialog dir="rtl" header="فاتورة الحجوزات" visible={Invoice} maximizable onHide={() => setInvoice(false)} maximized={window.innerWidth <= 1230 ? true : false}
                                style={selectedReservationes.length == 1 ? { width: '100mm', fontFamily: "Cairo", minHeight: "100vh" } : { width: '50vw', fontFamily: "Cairo", minHeight: "100vh" }}
                                footer={
                                    <center>
                                        <Button label="إغلاق" icon="pi pi-times" severity="danger" outlined onClick={() => setInvoice(false)}></Button>
                                    </center>
                                }

                            >
                                {selectedReservationes.length == 1 ?

                                    <ServiceReceiptMini
                                        bookingData={selectedReservationes[0]}
                                        customerData={selectedReservationes[0]}
                                        reservationData={selectedReservationes[0]}
                                        props={{ hideDialog: () => setInvoice(false) }}
                                    /> :
                                    <InvoiceContext.Provider value={selectedReservationes} >
                                        {Invoice && <InvoiceBookinges></InvoiceBookinges>}
                                    </InvoiceContext.Provider>

                                }
                            </Dialog>
                        )
                        :
                        (null)
                }
                {
                    ViewPaid ?
                        (
                            <Dialog dir="rtl" header="إيصال قبض" visible={ViewPaid} maximizable style={{ width: '60vw', fontFamily: "Cairo" }} onHide={() => setViewPaid(false)} maximized={window.innerWidth <= 1230 ? true : false}>
                                <InvoiceContext.Provider value={
                                    {
                                        customer: {
                                            ID_customer: selectedReservationes[0].ID_customer,
                                            visitor_name: selectedReservationes[0].visitor_name,
                                            phone_number: selectedReservationes[0].phone_number,
                                            whatsapp_number: selectedReservationes[0].whatsapp_number,
                                        },
                                        "reservations": selectedReservationes,
                                        "setViewPaid": setViewPaid,
                                        "GetReservationesComing": GetReservationesComing,
                                        "GetReservationesNow": GetReservationesNow,
                                        "GetReservationesOld": GetReservationesOld,
                                        "setSelectedReservationes": setSelectedReservationes,
                                        "setDataPaid": setDataPaid,
                                        "setInvoicePaid": setInvoicePaid,
                                        "toast": toast,
                                    }
                                } >
                                    <PayReservations></PayReservations>

                                </InvoiceContext.Provider>
                            </Dialog>
                        )
                        :
                        (null)
                }

                <Dialog dir="rtl" header="فاتورة الحجوزات العميل" visible={InvoicePaid} maximizable style={{ width: '60vw', fontFamily: "Cairo" }} onHide={() => setInvoicePaid(false)} maximized={window.innerWidth <= 1230 ? true : false}>
                    {
                        InvoicePaid ?
                            dataPaid?.reservations?.length == 1 && dataPaid?.reservations[0]?.reservation_type == 'service' ?
                                <ServiceReceiptMini
                                    bookingData={dataPaid?.customer?.reservationes.length > 0 ? dataPaid?.customer?.reservationes[0] : null}
                                    customerData={dataPaid?.customer}
                                    reservationData={dataPaid?.customer?.reservationes.length > 0 ? dataPaid?.customer?.reservationes[0] : null}
                                />
                                :
                                <InvoiceContext.Provider value={dataPaid?.reservations} >
                                    {InvoicePaid && <InvoiceBookinges></InvoiceBookinges>}
                                </InvoiceContext.Provider>

                            : <></>
                    }
                </Dialog>
                {
                    ViewDelete ?
                        (
                            <>
                                <Dialog dir="rtl" header="إلغاء حجوزات" visible={ViewDelete} maximizable style={{ width: '60vw', fontFamily: "Cairo" }} onHide={() => setViewDelete(false)} maximized={window.innerWidth <= 1230 ? true : false}>
                                    <InvoiceContext.Provider value={
                                        {
                                            customer: {
                                                ID_customer: selectedReservationes[0]?.ID_customer,
                                                visitor_name: selectedReservationes[0]?.visitor_name,
                                                phone_number: selectedReservationes[0]?.phone_number,
                                                whatsapp_number: selectedReservationes[0]?.whatsapp_number,
                                            },
                                            "reservations": selectedReservationes,
                                            "setViewDelete": setViewDelete,
                                            "GetReservationesComing": GetReservationesComing,
                                            "setSelectedReservationes": setSelectedReservationes,
                                            "setDataPaid": setDataPaid,
                                            "setInvoiceDelete": setInvoiceDelete,
                                            "toast": toast,
                                        }
                                    } >
                                        <DelReservations reservation_type="service"></DelReservations>
                                    </InvoiceContext.Provider>
                                </Dialog>
                            </>
                        )
                        :
                        (null)
                }
                {
                    InvoiceDelete ?
                        (
                            <>
                                <Dialog dir="rtl" header="فاتورة الحجوزات الملغية" visible={true} onHide={() => setInvoiceDelete(false)} maximized={window.innerWidth <= 1230 ? true : false}
                                    style={dataPaid?.reservations?.length == 1 ? { width: '100mm', fontFamily: "Cairo", minHeight: "100vh" } : { width: '50vw', fontFamily: "Cairo", minHeight: "100vh" }}
                                    footer={
                                        <center>
                                            <Button label="إغلاق" icon="pi pi-times" severity="danger" outlined onClick={() => setInvoiceDelete(false)}></Button>
                                        </center>
                                    }

                                >
                                    {dataPaid?.reservations?.length == 1 ?
                                        <ServiceReceiptMini
                                            bookingData={dataPaid?.reservations[0]}
                                            customerData={dataPaid?.customer}
                                            reservationData={dataPaid?.reservations[0]}
                                            state={'delete'}
                                            props={{ hideDialog: () => setInvoiceDelete(false) }}
                                        /> :
                                        <InvoiceContext.Provider value={dataPaid} >
                                            {dataPaid && <InvoiceCustomerDelete></InvoiceCustomerDelete>}
                                        </InvoiceContext.Provider>

                                    }

                                </Dialog>
                            </>

                        )
                        :
                        (null)
                }
            </div>
        </div>
    )
}

export default Bookinges


